// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `


.BodyCard{
    background-color: #D2E0E3;
}
.divCardsButtons{
    display: flex;
    justify-content: center;
    align-items: baseline;
    align-content: center;
    flex-direction: column;
    
}
#labelDate {
    background-color: #FCF0CC;

    border-radius: 12px;
}
.ActiveLabel{
    background-color: #FDDC79 !important;
}

.deactiveLabel{
    background-color: #FCF0CC  !important;
}
#labelDate input{
    background-color: transparent;
    border: none;
    text-align: center;
    border-radius: 15px;
    height: 35px;
}
.CompleteButtons{
    background-color: whitesmoke;
    /* display: flex;
    justify-content: center;
    align-items: start;
    align-content: start;
    flex-direction: column; */
}
.ButtonCards{
    background-color: #FCF0CC;
    width: 90%;
    border: none;
    border-radius: 12px;
    color: black;
    margin-top: 10px;
}

.CheckboxDiv{
    padding-top: 10px;
    width: 90%;
    display: flex;
    text-align: left;
    align-content: center;
    align-items: center;
    justify-content: flex-start;
}

.form-check-input:checked{
    background-color: #FDDC79;
    border-color: #FDDC79;
}

.ritiroHeader{
    background-color: #D2E0E3;
    border: none;
    font-weight: bold;
}

#containerOrari{
    padding: 20px;
    border-radius: 20px;
    display: flex;
    background-color: #FDFBF7;
    flex-direction: column;
    align-items: center;
    max-width: 374px;
    font-size: 12px;
    color: #000;
    font-weight: 600;
    white-space: nowrap;
}

.orario{
    width: 95%;
    border-radius: 4px;
    margin: 2px;
}


.orarioCard{
    border-radius: 0px 0px 12px 12px;
    background-color: #D2E0E3 !important;
}

.rs-slider-progress-bar{
    background-color: #D2E0E3 !important;

    border-color: lightgray !important;
    width: 1px;
}

.rs-slider-graduator > ol > li.rs-slider-pass::before{
   
    background-color: #FDDC79 !important;
    /* border-color:  #FDDC79 !important; */
    border: none !important;
}

.rs-slider-handle::before{
    background-color: #FCF0CC !important;
    border-color: #FDDC79 !important;
}
@media only screen and (max-width: 767px) {
    
    #containerOrari{
        min-width: 220px;
        max-width: 320px;
    }
    .divCardsButtons{
      
        flex-direction: column;
        align-items: center;
    }
    #labelDate{
        margin-top: 10px;
    }
  }
  @media only screen and (min-width: 768px) and (max-width: 1050px){
    #containerOrari{
        min-width: 320px;
        max-width: 420px;
    }
    .ActiveLabel{
        background-color: #FDDC79;
    }
    
    .deactiveLabel{
        background-color: #FCF0CC;
    }
    #labelDate {
        background-color: #FCF0CC;
        margin-top: 10px;
        border-radius: 12px;
    }
    .divCardsButtons{
        gap: 30px;
        flex-direction: row;
    }
  }
  @media only screen and (min-width: 1050px) {
    #containerOrari{
        min-width: 420px;
        max-width: 525px;
    }
    .divCardsButtons{
        gap: 30px;
        flex-direction: row;
    }
    .oggi{
        width: 300px;
    }
    .domani{
        width: 300px;
    }
    .dataBtn{
        width: 500px;
    }
    .ActiveLabel{
        background-color: #FDDC79;
    }
    
    .deactiveLabel{
        background-color: #FCF0CC;
    }
    #labelDate {
        background-color: #FCF0CC;
        margin-top: 10px;
        border-radius: 12px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/RitiroCard/RitiroCard.css"],"names":[],"mappings":";;;AAGA;IACI,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,qBAAqB;IACrB,sBAAsB;;AAE1B;AACA;IACI,yBAAyB;;IAEzB,mBAAmB;AACvB;AACA;IACI,oCAAoC;AACxC;;AAEA;IACI,qCAAqC;AACzC;AACA;IACI,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,4BAA4B;IAC5B;;;;6BAIyB;AAC7B;AACA;IACI,yBAAyB;IACzB,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,WAAW;AACf;;;AAGA;IACI,gCAAgC;IAChC,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;;IAEpC,kCAAkC;IAClC,UAAU;AACd;;AAEA;;IAEI,oCAAoC;IACpC,uCAAuC;IACvC,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;IACpC,gCAAgC;AACpC;AACA;;IAEI;QACI,gBAAgB;QAChB,gBAAgB;IACpB;IACA;;QAEI,sBAAsB;QACtB,mBAAmB;IACvB;IACA;QACI,gBAAgB;IACpB;EACF;EACA;IACE;QACI,gBAAgB;QAChB,gBAAgB;IACpB;IACA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;IACA;QACI,yBAAyB;QACzB,gBAAgB;QAChB,mBAAmB;IACvB;IACA;QACI,SAAS;QACT,mBAAmB;IACvB;EACF;EACA;IACE;QACI,gBAAgB;QAChB,gBAAgB;IACpB;IACA;QACI,SAAS;QACT,mBAAmB;IACvB;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;IAChB;IACA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;IACA;QACI,yBAAyB;QACzB,gBAAgB;QAChB,mBAAmB;IACvB;EACF","sourcesContent":["\n\n\n.BodyCard{\n    background-color: #D2E0E3;\n}\n.divCardsButtons{\n    display: flex;\n    justify-content: center;\n    align-items: baseline;\n    align-content: center;\n    flex-direction: column;\n    \n}\n#labelDate {\n    background-color: #FCF0CC;\n\n    border-radius: 12px;\n}\n.ActiveLabel{\n    background-color: #FDDC79 !important;\n}\n\n.deactiveLabel{\n    background-color: #FCF0CC  !important;\n}\n#labelDate input{\n    background-color: transparent;\n    border: none;\n    text-align: center;\n    border-radius: 15px;\n    height: 35px;\n}\n.CompleteButtons{\n    background-color: whitesmoke;\n    /* display: flex;\n    justify-content: center;\n    align-items: start;\n    align-content: start;\n    flex-direction: column; */\n}\n.ButtonCards{\n    background-color: #FCF0CC;\n    width: 90%;\n    border: none;\n    border-radius: 12px;\n    color: black;\n    margin-top: 10px;\n}\n\n.CheckboxDiv{\n    padding-top: 10px;\n    width: 90%;\n    display: flex;\n    text-align: left;\n    align-content: center;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n.form-check-input:checked{\n    background-color: #FDDC79;\n    border-color: #FDDC79;\n}\n\n.ritiroHeader{\n    background-color: #D2E0E3;\n    border: none;\n    font-weight: bold;\n}\n\n#containerOrari{\n    padding: 20px;\n    border-radius: 20px;\n    display: flex;\n    background-color: #FDFBF7;\n    flex-direction: column;\n    align-items: center;\n    max-width: 374px;\n    font-size: 12px;\n    color: #000;\n    font-weight: 600;\n    white-space: nowrap;\n}\n\n.orario{\n    width: 95%;\n    border-radius: 4px;\n    margin: 2px;\n}\n\n\n.orarioCard{\n    border-radius: 0px 0px 12px 12px;\n    background-color: #D2E0E3 !important;\n}\n\n.rs-slider-progress-bar{\n    background-color: #D2E0E3 !important;\n\n    border-color: lightgray !important;\n    width: 1px;\n}\n\n.rs-slider-graduator > ol > li.rs-slider-pass::before{\n   \n    background-color: #FDDC79 !important;\n    /* border-color:  #FDDC79 !important; */\n    border: none !important;\n}\n\n.rs-slider-handle::before{\n    background-color: #FCF0CC !important;\n    border-color: #FDDC79 !important;\n}\n@media only screen and (max-width: 767px) {\n    \n    #containerOrari{\n        min-width: 220px;\n        max-width: 320px;\n    }\n    .divCardsButtons{\n      \n        flex-direction: column;\n        align-items: center;\n    }\n    #labelDate{\n        margin-top: 10px;\n    }\n  }\n  @media only screen and (min-width: 768px) and (max-width: 1050px){\n    #containerOrari{\n        min-width: 320px;\n        max-width: 420px;\n    }\n    .ActiveLabel{\n        background-color: #FDDC79;\n    }\n    \n    .deactiveLabel{\n        background-color: #FCF0CC;\n    }\n    #labelDate {\n        background-color: #FCF0CC;\n        margin-top: 10px;\n        border-radius: 12px;\n    }\n    .divCardsButtons{\n        gap: 30px;\n        flex-direction: row;\n    }\n  }\n  @media only screen and (min-width: 1050px) {\n    #containerOrari{\n        min-width: 420px;\n        max-width: 525px;\n    }\n    .divCardsButtons{\n        gap: 30px;\n        flex-direction: row;\n    }\n    .oggi{\n        width: 300px;\n    }\n    .domani{\n        width: 300px;\n    }\n    .dataBtn{\n        width: 500px;\n    }\n    .ActiveLabel{\n        background-color: #FDDC79;\n    }\n    \n    .deactiveLabel{\n        background-color: #FCF0CC;\n    }\n    #labelDate {\n        background-color: #FCF0CC;\n        margin-top: 10px;\n        border-radius: 12px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
